export const EXPERIMENTAL_FLAG = 'experimental';

export const NO_BARCODE_DETECTED = 'No barcode detected';

export const ACCEPTED_MIME_TYPES = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/apng',
  'image/gif',
  'image/webp',
  'image/avif'
];
